import _ceil from "lodash/ceil";
import { amortize } from './amortize';
import { MIN_LOAN_AMOUNT } from '../data/constants';
export default function validateLoanAmount(_ref) {
  var annualIncome = _ref.annualIncome,
      annualInterestRate = _ref.annualInterestRate,
      dti = _ref.dti,
      loanTermMonths = _ref.loanTermMonths,
      loanAmount = _ref.loanAmount,
      monthlyMortgagePayment = _ref.monthlyMortgagePayment,
      monthlyDebt = _ref.monthlyDebt;

  if (loanAmount < MIN_LOAN_AMOUNT) {
    var minMonthlyPayment = amortize({
      loanAmount: MIN_LOAN_AMOUNT,
      annualInterestRate: annualInterestRate,
      loanTermMonths: loanTermMonths
    }); // prevent floating point issues by rounding up to the nearest dollar

    var paymentDelta = _ceil(minMonthlyPayment - monthlyMortgagePayment);

    return {
      error: {
        monthlyDebt: paymentDelta > monthlyDebt ? monthlyDebt : monthlyDebt - paymentDelta,
        annualIncome: paymentDelta / dti * 12 + annualIncome
      },
      loanAmount: MIN_LOAN_AMOUNT,
      monthlyMortgagePayment: minMonthlyPayment
    };
  }

  return {
    error: null,
    loanAmount: loanAmount,
    monthlyMortgagePayment: monthlyMortgagePayment
  };
}